import React from 'react';
import {connect} from 'react-redux';
import {change, Field, InjectedFormProps, reduxForm} from 'redux-form'
import {AppState} from "@Redux/store";
import {CardBody, Col, FormGroup} from "reactstrap";
import ReduxFormInput from "@Utils/ReduxFormInput";
import Repeater from "@Utils/Repeater";
import Card from "../utils/Card";
import {CardDisplay} from "../utils/CardDisplay";
import {Dispatch} from "@Redux/type";
import {container} from "@Container";
import {ArmiesAction} from "@Redux/actions";
import {TYPES} from "@Types";
import {TeamArmyView} from "@Selectors/tool/pairing/create/view/TeamArmyView";
import {selectTeamArmiesPresenter} from "@Selectors/tool/pairing/create/selectTeamArmiesPresenter";
import ReduxFormTeamArmyBlock from "@Utils/ReduxFormTeamArmyBlock";
import validate, {CreateDraftTeamParams} from "@Components/draft/create/DraftTeamValidate";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  onSubmit: (values: CreateDraftTeamParams) => void
}

const Form: React.FC<FormProps & InjectedFormProps<CreateDraftTeamParams, FormProps>> = ({
                                                                                       selection,
                                                                                       handleSubmit,
                                                                                       fetchData,
                                                                                       selectArmy,
                                                                                       updatePlayerName,
                                                                                       unselectArmy,
                                                                                     }) => {
  React.useEffect(() => {
    fetchData();
  }, []);

  if (selection.hasError) {
    return <p><FormattedMessage {...defaultMessages.toolPairingSelectArmiesError} /></p>;
  }

  if (selection.isArmiesLoading) {
    return <div className="loader"></div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <CardBody>
        <h1 className="text-center"><FormattedMessage {...defaultMessages.toolPairingTeamNameWhatName} /></h1>

        <FormGroup row={true} className="text-center justify-content-md-center">
          <Col xs={12} md={4}>
            <Field
              name="name"
              type="text"
              component={ReduxFormInput}
              label={defaultMessages.toolPairingTeamNameYourName}
              placeHolder={defaultMessages.toolPairingTeamNameYourName}
            />
          </Col>
          <Col xs={12}>
            <Field
              name="teamArmies"
              datas={selection.teamArmies}
              unselectArmy={unselectArmy}
              updatePlayerName={updatePlayerName}
              component={ReduxFormTeamArmyBlock}
              label={defaultMessages.toolPairingFormArmiesLabel}
            />
          </Col>
          <Col xs={12}>
              <button className="btn btn-age btn-lg m-3"><FormattedMessage {...defaultMessages.formValidate} /></button>
          </Col>
        </FormGroup>
        <FormGroup row={true} className="justify-content-md-center list-armies">
          <Repeater data={selection.armies} indexPrefix='army'>
            {
              (item: TeamArmyView) =>
                <Card display={CardDisplay.ARMY}
                      selectable={item.selectable}
                      army={item}
                      selected={item.selected}
                      select={() => selectArmy(selection.size, selection.teamArmies, item)}/>
            }
          </Repeater>
        </FormGroup>
      </CardBody>
    </form>
  )
}

const FORM_NAME = 'create_team';
const CreateDraftTeamForm = reduxForm<CreateDraftTeamParams, FormProps>({
  form: FORM_NAME,
  validate,
})(Form);

const mapStateToProps = (state: AppState) => ({
  selection: selectTeamArmiesPresenter(state),
  initialValues: {
    size: state.draft.entity!.size,
    name: '',
    teamArmies: [],
  }
})

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction)

  return {
    fetchData: () => dispatch(armiesAction.fetchData()),
    selectArmy: (size: number, teamArmies: Array<TeamArmyView>, army: TeamArmyView) => {
      const myTeamArmies = teamArmies.filter(item => item.armyId > 0);
      if (myTeamArmies.some(item => item.armyId === army.armyId)) {
        const selected = myTeamArmies.filter(item => item.armyId !== army.armyId)
        dispatch(change(FORM_NAME, 'teamArmies', selected));
        return
      }
      const seleted = myTeamArmies.concat(TeamArmyView.fromArmy(army.army!, true, true))
      dispatch(change(FORM_NAME, 'teamArmies', seleted));
    },
    updatePlayerName: (teamArmies: Array<TeamArmyView>, index: number, name: string) => {
      const myTeamArmies = teamArmies.map((item, current) => {
        if (current === index) {
          item.playerName = name;
        }
        return item
      });
      dispatch(change(FORM_NAME, 'teamArmies', myTeamArmies));
    },
    unselectArmy: (teamArmies: Array<TeamArmyView>, army: TeamArmyView) => {
      const seleted = teamArmies.filter(item => item.armyId > 0)
        .filter(item => item.armyId !== army.armyId)
      dispatch(change(FORM_NAME, 'teamArmies', seleted));
    },
  };
};

type FormProps = Props &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(CreateDraftTeamForm);
